import { dibujarQrVectorial } from './qrVectorial';

const abortar = () => new DOMException('Preparación cancelada', 'AbortError');

async function esperarArte(img, signal) {
  if (signal?.aborted) throw abortar();
  if (!img) throw new Error('No hay arte de entrada.');
  if (img.complete) {
    if (!img.naturalWidth || !img.naturalHeight) throw new Error('El arte de entrada no se cargó.');
    return;
  }
  await new Promise((resolve, reject) => {
    const cleanup = () => { clearTimeout(timer); img.removeEventListener('load', loaded); img.removeEventListener('error', failed); signal?.removeEventListener('abort', cancelled); };
    const loaded = () => { cleanup(); resolve(); };
    const failed = () => { cleanup(); reject(new Error('No se pudo cargar el arte de entrada.')); };
    const cancelled = () => { cleanup(); reject(abortar()); };
    const timer = setTimeout(failed, 15000);
    img.addEventListener('load', loaded); img.addEventListener('error', failed);
    signal?.addEventListener('abort', cancelled, { once: true });
  });
}
const localRect = (node, origin) => {
  const r = node.getBoundingClientRect();
  return { x: r.left - origin.left, y: r.top - origin.top, width: r.width, height: r.height };
};

// Reutiliza el arte y los QR ya emitidos: no clona HTML ni vuelve a consultar datos.
export async function prepararPngEntradasReserva(items, nodos, { signal, onProgress = () => {} } = {}) {
  if (!items?.length || nodos.length !== items.length) throw new Error('Faltan renders de entrada. No se enviará una entrega incompleta.');
  if (signal?.aborted) throw abortar();
  const renders = Array.from(nodos, node => node?.querySelector('.palma-entrada-render'));
  if (renders.some(node => !node)) throw new Error('No hay render de entrada. No se generará un archivo vacío.');
  await Promise.all(renders.map(node => esperarArte(node.querySelector('.palma-entrada-bg'), signal)));
  await document.fonts?.ready;
  // React aplica el aspect ratio tras cargar el arte. No usamos frames de documentos ocultos.
  await new Promise(resolve => requestAnimationFrame(() => requestAnimationFrame(resolve)));
  const base = document.createElement('canvas'), canvas = document.createElement('canvas');
  let baseKey = '';
  try {
    const files = [];
    for (let i = 0; i < items.length; i++) {
      if (signal?.aborted) throw abortar();
      const source = renders[i], origin = source.getBoundingClientRect();
      if (!origin.width || !origin.height) throw new Error('El render de entrada no tiene dimensiones.');
      const img = source.querySelector('.palma-entrada-bg');
      const qr = source.querySelector('.palma-entrada-qr'), qrGraphic = qr?.querySelector('svg, canvas');
      if (!qrGraphic) throw new Error('Falta el QR de una entrada.');
      const width = Math.round(origin.width * 3), height = Math.round(origin.height * 3);
      const key = `${img.currentSrc || img.src}|${width}|${height}`;
      if (baseKey !== key) {
        base.width = width; base.height = height;
        const bg = base.getContext('2d'); bg.scale(3, 3);
        bg.fillStyle = '#ffffff'; bg.fillRect(0, 0, origin.width, origin.height);
        const r = localRect(img, origin);
        const factor = Math.max(r.width / img.naturalWidth, r.height / img.naturalHeight);
        const w = img.naturalWidth * factor, h = img.naturalHeight * factor;
        bg.drawImage(img, r.x + (r.width - w) / 2, r.y + (r.height - h) / 2, w, h);
        baseKey = key;
      }
      canvas.width = width; canvas.height = height;
      const ctx = canvas.getContext('2d'); ctx.drawImage(base, 0, 0); ctx.scale(3, 3);
      const r = localRect(qr, origin), q = localRect(qrGraphic, origin);
      const radius = parseFloat(getComputedStyle(qr).borderRadius) || 0;
      ctx.fillStyle = '#ffffff';
      // El render canónico tiene un contorno blanco exterior de 2 px.
      ctx.beginPath(); ctx.roundRect(r.x - 2, r.y - 2, r.width + 4, r.height + 4, radius + 2); ctx.fill();
      ctx.imageSmoothingEnabled = false;
      if (qrGraphic.tagName.toLowerCase() === 'svg') dibujarQrVectorial(ctx, qrGraphic, q, 3);
      else ctx.drawImage(qrGraphic, q.x, q.y, q.width, q.height);
      const blob = await new Promise(resolve => canvas.toBlob(resolve, 'image/png'));
      if (!blob) throw new Error('PNG vacío.');
      if (signal?.aborted) throw abortar();
      files.push(new File([blob], `entrada-${items[i].id}.png`, { type: 'image/png' }));
      onProgress(i + 1);
      await new Promise(resolve => setTimeout(resolve, 0));
    }
    return files;
  } finally { base.width = base.height = canvas.width = canvas.height = 0; }
}

// Compatibilidad para consumidores que necesitan un único PNG en base64.
export async function capturarEntradaReserva(node) {
  const [file] = await prepararPngEntradasReserva([{ id: 'captura' }], [node]);
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result).split(',')[1]);
    reader.onerror = () => reject(new Error('No se pudo leer el PNG.'));
    reader.readAsDataURL(file);
  });
}
